import { Adapter as r } from "../../../../../adapter.js";
import { ShopSessionDropOffModel as s } from "./dropOff.model.js";
class t extends r {
  adapt(e) {
    return new s({
      address: e.address,
      addressExtra: e.addressExtra,
      latitude: e.latitude,
      longitude: e.longitude,
      fullAdress: e.fullAdress
    });
  }
  serialize(e) {
  }
}
export {
  t as ShopSessionDropOffAdapter
};
//# sourceMappingURL=dropOff.adapter.js.map
